import { FC } from "react";
import { Flex } from "@chakra-ui/react";
// eslint-disable-next-line no-restricted-imports
import { RequiredLinks } from "~/components/Footer/RequiredLinks";
import { sharedProps } from "~/constants";

export const SimpleFooter: FC = () => {
  return (
    <Flex
      align="center"
      as="footer"
      bg="fg-accent"
      direction="column"
      justify="center"
      py={8}
      {...sharedProps.fullBleed}
    >
      <RequiredLinks />
    </Flex>
  );
};
